import React, { useState } from 'react';
import './SignInSheet.css';
import { signInWithGoogle } from '../utils/authHelpers';
import { signInAnonymously } from 'firebase/auth';
import { auth } from '../firebase';
import { trackSignIn } from '../utils/analytics';

// Google G icon — official brand SVG
const GoogleIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" aria-hidden="true">
    <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
    <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
    <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.84z"/>
    <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
  </svg>
);

function SignInSheet({ onDismiss }) {
  const [loading, setLoading] = useState(null); // 'google' | 'guest' | null
  const [error, setError]     = useState(null);

  const handleGoogle = async () => {
    setLoading('google');
    setError(null);
    try {
      trackSignIn('google');
      await signInWithGoogle();
      // Page will redirect to Google — loading state stays until redirect
    } catch (err) {
      setError('Something went wrong. Please try again.');
      setLoading(null);
    }
  };

  const handleGuest = async () => {
    setLoading('guest');
    setError(null);
    try {
      trackSignIn('guest');
      await signInAnonymously(auth);
      // onAuthStateChanged in App.js will close the sheet
    } catch {
      setError('Something went wrong. Please try again.');
      setLoading(null);
    }
  };

  return (
    <div className="signin-overlay" role="dialog" aria-modal="true" aria-label="Sign in to ChopMyShop">
      <div className="signin-sheet">

        {/* Branding */}
        <div className="signin-brand">
          <img src="/ChopMyShop Logo.svg" alt="ChopMyShop" className="signin-logo" />
        </div>

        <div className="signin-penny">
          <img src="/penny-avatar.png" alt="" className="signin-penny-img" aria-hidden="true" />
        </div>

        <h2 className="signin-headline">See where your full shop is cheapest</h2>
        <p className="signin-sub">
          Compare your full list across stores before you go.
        </p>

        {/* Feature bullets */}
        <ul className="signin-perks">
          <li className="signin-perk signin-perk--guest">
            <span className="signin-perk-icon">👀</span>
            <span>Browse and compare prices for free</span>
          </li>
          <li className="signin-perk">
            <span className="signin-perk-icon">💾</span>
            <span>Sign in to save your lists across devices</span>
          </li>
          <li className="signin-perk">
            <span className="signin-perk-icon">🧾</span>
            <span>Sign in to keep your receipt history</span>
          </li>
        </ul>

        {error && <p className="signin-error">{error}</p>}

        {/* CTAs — guest is primary (less friction), Google is secondary */}
        <div className="signin-actions">
          <button
            className="signin-btn signin-btn--guest"
            onClick={handleGuest}
            disabled={!!loading}
          >
            {loading === 'guest' ? (
              <span className="signin-spinner signin-spinner--muted" aria-hidden="true" />
            ) : null}
            Continue as guest
          </button>

          <button
            className="signin-btn signin-btn--google"
            onClick={handleGoogle}
            disabled={!!loading}
          >
            {loading === 'google' ? (
              <span className="signin-spinner" aria-hidden="true" />
            ) : (
              <GoogleIcon />
            )}
            Continue with Google
          </button>
        </div>

        <p className="signin-legal">
          Sign in to save your lists across devices.{' '}
          <a href="/privacy" className="signin-link">Privacy Policy</a>.
        </p>

      </div>
    </div>
  );
}

export default SignInSheet;
